// extracted by mini-css-extract-plugin
export default {"select":"LocationPanelDetails_select__ARmF8"};